import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-record-payment',
  templateUrl: './record-payment.component.html',
  styleUrls: ['./record-payment.component.scss']
})
export class RecordPaymentComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
  ) { }


  // @Input() openModal:any;
    // content='content'

  ngOnInit(): void {
    // this.modalService.open(content, { size: 'md', centered: true });
  }

  

  customerGroup:any = {
    "gorup_name":"",
    "customer_ids":[]
    }

}
